// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1mTVp","header":"MergedInvoice_header__3S7Cw"};